module.exports = __webpack_public_path__ + "img/CM-SL-CA-Kia-Lifestyle-1.18361be4.jpg";